import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/Button';
import ItemDetails from 'components/ItemDetails';
import ContactAgentModal from 'components/modal/ContactAgentModal';
import { setSelectedBooking } from 'reducers/ui/uiSlice';
import { BUTTON_TYPE_LINK } from 'shared/constants/common';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { displayAmount, displayDate } from 'shared/helpers/common';
import {
  getQuoteBookingComponentOverview,
  getPassengersToDisplay,
  generateTitle,
} from 'shared/helpers/quoteBooking';

export default function BookingsItem({ booking = {} }) {
  const [openModal, setOpenModal] = useState(false);
  const [isLoyaltyBooking, setIsLoyaltyBooking] = useState(false);
  const { componentConfig } = useSelector((state) => state.ui);

  const dispatch = useDispatch();

  const {
    id,
    reference,
    currency,
    currentPrice,
    price,
    passengerSummary,
    author = {},
    outbound,
    destination,
    destinations,
    accommodation,
    cruises,
    tours,
    flights,
    due,
    balanceDueDate,
  } = booking;

  const {
    name: componentName,
    dateToDisplay,
    componentType,
  } = getQuoteBookingComponentOverview(booking);

  const passengerDisplay = getPassengersToDisplay(passengerSummary);

  const selectBooking = () => {
    dispatch(setSelectedBooking(booking));
  };

  const openModalHandler = () => {
    setOpenModal(!openModal);
  };

  useEffect(() => {
    const foundLoyalty = booking.tours.some(tour => tour.loyalty === true);
    setIsLoyaltyBooking(foundLoyalty);
  }, [booking]);

  return (
    <>
      <div className="rounded-[10px] mt-[40px] bg-white flex flex-col lg:flex-row lg:justify-between">
        <ItemDetails
          className="p-4 w-full"
          title={generateTitle(
            outbound,
            destination,
            destinations,
            accommodation,
            cruises,
            tours,
            flights,
            isLoyaltyBooking,
            true,
          )}
          componentType={componentType}
          componentName={componentName}
          date={dateToDisplay}
          guest={passengerDisplay}
          totalPrice={displayAmount(currentPrice || price, currency)}
          due={displayAmount(due, currency)}
          balanceDueDate={displayDate(balanceDueDate, '-', undefined, true)}
          reference={reference}
          isLoyaltyBooking={isLoyaltyBooking}
          isHorizontal
        />
        <div
          className={`flex flex-col border-t lg:border-l lg:border-t-0 lg:w-[300px]
          ${
            componentConfig.contactAgentEnabled
              ? 'lg:justify-center'
              : 'lg:justify-end'
          }`}
        >
          {componentConfig.contactAgentEnabled && (
            <Button
              label="Message Customer Services"
              secondary
              className="mt-3 mx-3 !text-[13px]"
              onClick={openModalHandler}
            />
          )}
          <Button
            label="View booking"
            className="m-3"
            type={BUTTON_TYPE_LINK}
            onClick={selectBooking}
            url={`${ROUTES_SELF_SERVICE.BOOKINGS}/${id || reference}`}
          />
        </div>
      </div>
      <ContactAgentModal
        assignee={author}
        reference={reference}
        openModal={openModal}
        setOpenModal={setOpenModal}
        showReference
        context="booking"
      />
    </>
  );
}
